/* eslint-disable no-unused-vars */
import React from 'react';
import style from './dropCircle.module.scss';
import cx from 'classnames';

export default function DropCircle({
  x,
  y,
  isVisible,
}: {
  x: number;
  y: number;
  isVisible: boolean;
}) {
  return (
    <div
      style={{
        transform: `translate(calc(${x}px - 50%), calc(${y}px - 50%))`,
      }}
      className={cx(style.container, isVisible ? '' : 'hidden')}
    ></div>
  );
}
